import React, { Component } from 'react';
import PropTypes from 'prop-types';
import radium, { Style } from 'radium';
import Relay from 'react-relay/classic';
import QuestionAnswerItem from './QuestionAnswerItem';

class PeerReview extends Component {
  static styles = {};

  static contextTypes = {
    submissionOn: PropTypes.func
  };

  componentDidMount() {
    this.context.submissionOn && this.context.submissionOn(true);
  }

  componentWillUnmount() {
    this.context.submissionOn && this.context.submissionOn(false);
  }

  renderSubmissions() {
    const styles = PeerReview.styles;

    return (
      <div>
        <div>
          <div style={[styles.submissionContainer, styles.displayFlexColumn]}>
            <div style={styles.answersContainer}>
              <QuestionAnswerItem
                rootQ={this.props.rootQ}
                course={this.props.course}
                userId={this.props.relay.variables.userId}
                previousCard={this.props.previousCard}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (!this.props.rootQ) {
      return null;
    }

    const styles = PeerReview.styles;
    // const submissions = course.userSubmissions;
    // const user = course.user;
    return (
      <div className="PeerReviewContainer">
        {this.renderSubmissions()}
        <Style rules={styles.classBased} scopeSelector=".PeerReviewContainer" />
      </div>
    );
  }
}

PeerReview.styles = {
  classBased: {
    '': {
      // backgroundColor: '#fff',
      padding: '0',
      fontFamily: 'ProximaNova'
      // minHeight: 'calc(100vh - 138px)',
      // maxWidth: '680px',
      // margin: '0 auto',
    },
    '.failIcon': {
      width: '16px',
      height: '16px',
      marginRight: '8px',
      position: 'relative'
    },
    '.failIcon:before,.failIcon:after': {
      position: 'absolute',
      content: '""',
      height: '16px',
      width: '4px',
      backgroundColor: '#d63c3d',
      left: '6px'
    },
    '.failIcon:before': {
      transform: 'rotate(45deg)'
    },
    '.failIcon:after': {
      transform: 'rotate(-45deg)'
    },
    '.checkmark': {
      display: 'inline-block',
      width: '22px',
      height: '22px',
      transform: 'rotate(45deg)',
      marginRight: '6px'
    },
    '.checkmark_stem': {
      position: 'absolute',
      width: '4px',
      height: '16px',
      backgroundColor: '#0aaf79',
      left: '11px',
      top: '2px'
    },
    '.checkmark_kick': {
      position: 'absolute',
      width: '5px',
      height: '4px',
      backgroundColor: '#0aaf79',
      left: '6px',
      top: '14px'
    }
  },
  submissionContainer: {
    marginBottom: '20px'
  },
  displayFlexColumn: {
    display: 'flex',
    flexDirection: 'column'
  },
  displayFlexRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  submissionQuestionText: {
    fontSize: '14px',
    lineHeight: '19px',
    fontWeight: '500',
    letterSpacing: '0.1px',
    color: '#2d3c49',
    position: 'relative'
  },
  answersContainer: {
    // border: 'solid 1px #dbe2e8',
    // padding: '20px 26px',
    borderRadius: '2px'
  },

  alignItemsCenter: {
    alignItems: 'center'
  },
  marginBottomZero: {
    marginBottom: '0px'
  },
  totalSubmissionsText: {
    fontSize: '14px',
    lineHeight: '17px',
    fontWeight: '500',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    color: '#767e86'
  },
  userDetails: {
    fontSize: '16px',
    lineHeight: '22px',
    fontWeight: '500',
    color: '#575766'
  },
  courseName: {
    color: '#4a90e2'
  },
  userDetailsContainer: {
    justifyContent: 'space-between',
    marginBottom: '35px'
  },
  userImageContainer: {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    overflow: 'hidden',
    marginRight: '7px',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.2)',
    display: 'flex'
  },
  userImage: {
    maxWidth: '100%'
  },
  titleContainer: {
    justifyContent: 'space-between',
    marginBottom: '20px'
  },
  userScoreInformation: {
    fontSize: '14px',
    lineHeight: '17px',
    fontWeight: '500',
    letterSpacing: '0.5px',
    textTransform: 'uppercase'
  },
  passColor: {
    color: '#0baf79'
  },
  failColor: {
    color: '#d63c3d'
  },
  marginRight8: {
    marginRight: '8px'
  },
  awaitingIcon: {
    marginRight: '6px'
  },
  awaitingSentenceBlock: {
    width: '100%',
    padding: '9px 44px',
    background: '#edf0f3',
    fontSize: '14px',
    lineHeight: '18px',
    color: '#36465d',
    margin: '16px -44px 20px'
  }
};

export default Relay.createContainer(radium(PeerReview), {
  initialVariables: {
    userId: null
  },
  fragments: {
    rootQ: variables => Relay.QL`
      fragment on Card {
        id
        pid
        name
        type
        ${QuestionAnswerItem.getFragment('rootQ')}
      }
    `
  }
});

// userSubmissions(userId:$userId, courseId:$courseId) {
//           id
//           pid
//           name
//         }
